import { render } from "./InforAccount.vue?vue&type=template&id=c57dc1f0&scoped=true"
import script from "./InforAccount.vue?vue&type=script&lang=js"
export * from "./InforAccount.vue?vue&type=script&lang=js"

import "./InforAccount.vue?vue&type=style&index=0&id=c57dc1f0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57dc1f0"]])

export default __exports__